import { Alert, Box, Button, Container, FormControl, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { useSelector,useDispatch } from 'react-redux';
import { ajoutsuccess,idretour,showapercu,modifsuccess } from "./RetoursSlice";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import Apercu from './Apercu';

export default function RetoursStock() {

  const retourData = useSelector(state => state.retoursData);
  const ajoutSuccess = retourData.ajoutsuccess;
  const modifSuccess = retourData.modifsuccess;
  const [Chargement, setChargement] = useState(false);
  const [listretours, setListretours] = useState([]);
  const [removeSuccess, setRemoveSuccess] = useState(false);
  const [Progession, setProgession] = useState(false);
  const [valType, setvalType] = useState('Tout');
  const [ListProduits,setListProduits] = useState([]);

  const userData = useSelector(state => state.userData)
  const id = userData.id;
  const typeCompte = userData.type
  const apitoken = userData.apitoken;
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const dispatch= useDispatch();

  const handleTypeChange = (event) => {
    setvalType(event.target.value);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(ajoutsuccess(false));
    dispatch(modifsuccess(false));
    setRemoveSuccess(false);
  };

  const formatDateToFrench = (dateString) => {
    const [date] = dateString.split('T');
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  };


  const isToday = (dateString) => {
  if (!dateString) return false;

  const retourDate = new Date(dateString);
  const today = new Date();

  return (
    retourDate.getFullYear() === today.getFullYear() &&
    retourDate.getMonth() === today.getMonth() &&
    retourDate.getDate() === today.getDate()
  );
};

  const modifier = (id) => {
    const filtreretour = listretours.filter(list => list._id === id);
    dispatch(idretour(filtreretour));
    navigate('/home/editretourstock');
  }

  const suppression = async (idretour)=> {
    setProgession(true)
    
    try {
        const response = await axios.post(`${apiUrl}delete/retourstock/${id}/${apitoken}/${idretour}`,
          {
            timeout: 20000,
          }
        );
        if(response.data.status==="ok")
            {
                const newlist=listretours.filter(achat => achat._id !== idretour);
                setListretours(newlist);
                setRemoveSuccess(true);
            }
    } catch (error) {
      navigate('/');
    }
    setProgession(false)
}

const supprimer = (id) => {
  let result = window.confirm(`Supprimer cette sortie ?`);
  if (result === true) {
      suppression(id);
  }
}

const ShowApercu=async (list) => {
  setListProduits(list)
  dispatch(showapercu(true))
}


const getValeurAchatRetour = (produits) => {
  return produits.reduce(
    (total, produit) =>
      total + ((produit.prix_achat || 0) * (produit.totalunite || 0)),
    0
  );
};

function ShowList() {

  let listFiltre = listretours;

  if (valType !== "Tout") {
    listFiltre = listFiltre.filter(retour => retour.type === valType);
  }

  const totalGeneral = listFiltre.reduce(
    (total, retour) => total + getValeurAchatRetour(retour.produits || []),
    0
  );

  if (listFiltre.length > 0) {

    return (
      <>
        {listFiltre.map(Retour => {

          const valeurAchatRetour = getValeurAchatRetour(
            Retour.produits || []
          );

          return (
            <StyledTableRow key={Retour._id}>
              <StyledTableCell component="th" scope="row">
                {Retour.type}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {Retour.remarque}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {Retour.utilisateur}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {Retour.date !== "" ? formatDateToFrench(Retour.date) : ''}
              </StyledTableCell>

              <StyledTableCell align="right">
                {valeurAchatRetour.toFixed(2)} DH
              </StyledTableCell>

              <StyledTableCell align="right">
                <Button
                  variant="outlined"
                  color='secondary'
                  startIcon={<VisibilityIcon />}
                  onClick={() => ShowApercu(Retour.produits)}
                >
                  Aperçu
                </Button>

                {typeCompte === "admin" ?
                  <>
                    <Button
                      sx={{ marginLeft: '10px' }}
                      variant="outlined"
                      color='warning'
                      startIcon={<EditIcon />}
                      onClick={() => modifier(Retour._id)}
                    >
                      Modifier
                    </Button>

                    <Button
                      sx={{ marginLeft: '10px' }}
                      variant="outlined"
                      color='error'
                      startIcon={<DeleteIcon />}
                      onClick={() => supprimer(Retour._id)}
                    >
                      Supprimer
                    </Button>
                  </>
                  :
                  ""
                }

                {typeCompte === "manager" && isToday(Retour.date) && (
                  <>
                    <Button
                      sx={{ marginLeft: '10px' }}
                      variant="outlined"
                      color='warning'
                      startIcon={<EditIcon />}
                      onClick={() => modifier(Retour._id)}
                    >
                      Modifier
                    </Button>

                    <Button
                      sx={{ marginLeft: '10px' }}
                      variant="outlined"
                      color='error'
                      startIcon={<DeleteIcon />}
                      onClick={() => supprimer(Retour._id)}
                    >
                      Supprimer
                    </Button>
                  </>
                )}
              </StyledTableCell>
            </StyledTableRow>
          );
        })}

        <StyledTableRow>
          <StyledTableCell colSpan={4}>
            <Typography fontWeight="bold">
              Total général
            </Typography>
          </StyledTableCell>

          <StyledTableCell align="right">
            <Typography fontWeight="bold">
              {totalGeneral.toFixed(2)} DH
            </Typography>
          </StyledTableCell>

          <StyledTableCell />
        </StyledTableRow>
      </>
    );

  } else {

    return (
      <StyledTableRow>
        <StyledTableCell align='center' colSpan={6}>
          Pas de données
        </StyledTableCell>
      </StyledTableRow>
    );

  }
}

const GetRetours=async () => {
  setChargement(true)
    try {
    const response = await axios.post(`${apiUrl}retourstock/${id}/${apitoken}`,
      {
        timeout: 20000,
      }
    );
    setListretours(response.data);
    }
  catch (error) {
    navigate('/');    
  }
  setChargement(false)
}


const Ajouter=() => {
  navigate('/home/nouveauretour');
  }

  useEffect(() =>{
    GetRetours()
    },[]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
    <Typography variant="h4" align='center' color="primary">
      Sortie de stock
        </Typography>

        <Box display="flex" width="100%" mt={5}>

<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={180} />
         :
<FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="demo-simple-select-label">Type retour</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valType}
          label="Type retour"
          onChange={handleTypeChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          <MenuItem value='Dégustation'>Dégustation</MenuItem>
          <MenuItem value='Cadeau'>Cadeau</MenuItem>
          <MenuItem value='Produits périmés'>Produits périmés</MenuItem>
          <MenuItem value='Produits dégradés'>Produits dégradés</MenuItem>
          

          </Select>
          </FormControl>
}
</Box>

            <Box style={{ marginLeft: 'auto' }}>

               {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :

        <Button variant="contained" size='large' color="primary" startIcon={<AddIcon/>} onClick={Ajouter} >
    Nouveau Retour
  </Button>  
} 
</Box>
        </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
          <StyledTableCell>Type retour</StyledTableCell>
            <StyledTableCell>Remarque</StyledTableCell>
            <StyledTableCell>Utilisateur</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="right">Valeur achat</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}

          <Snackbar open={ajoutSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Sortie ajoutée avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={modifSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Sortie modifiée avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Sortie supprimée avec succès
        </Alert>
      </Snackbar>
      <Apercu Chargements={ListProduits} />
        </Container>
  )
}
